import { Routes } from '@angular/router';
import { SvaxisComponent } from './svaxis/svaxis.component';
import { SVAXIS_ROUTES } from './svaxis/svaxis.router';
import { SvoptionFormComponent } from './svoption-form/svoption-form.component';
import { SvoptionListComponent } from './svoption-list/svoption-list.component';

export const SVOPTION_ROUTES: Routes = [
    { path: 'list/:idquestion', component: SvoptionListComponent },
    { path: 'add/:idquestion', component: SvoptionFormComponent },
    { path: 'edit/:id', component: SvoptionFormComponent },
    { path: 'axis', component:  SvaxisComponent, children: SVAXIS_ROUTES},
    { path: '**', pathMatch: 'full', redirectTo: 'list'}
];